module.exports = __webpack_public_path__ + "static/media/data_light_big.a3856020.svg";